import { gql } from '@apollo/client'

export default gql`
  fragment CourseChipComponent on ProductCourse {
    id
    slug
    title
    image {
      url
    }
    difficultyLevel
    length
  }
`
